import type { TrainingDataSource, TrainingSourceFilter } from '../config/trainingDataSources';
import { LIGHT_HEX } from './tokens';

/** Chart / D3 fill colors (light baseline; runtime charts may use getCssToken for theme). */
export const SOURCE_CHART_HEX: Record<TrainingDataSource, string> = {
  peach: LIGHT_HEX.rowing.yellow,
  concept2: LIGHT_HEX.rowing.blue,
};

export const SOURCE_BADGE_CLASS: Record<TrainingDataSource, string> = {
  peach: 'bg-source-peach-bg text-source-peach-fg border-source-peach-border',
  concept2: 'bg-source-concept2-bg text-source-concept2-fg border-source-concept2-border',
};

export const SOURCE_METRIC_LABEL_CLASS: Record<TrainingDataSource, string> = {
  peach: 'text-source-peach-fg',
  concept2: 'text-source-concept2-fg',
};

const SOURCE_FILTER_SEGMENT_CLASS: Record<
  TrainingDataSource,
  { active: string; inactive: string }
> = {
  peach: {
    active: 'border border-source-peach-border bg-transparent text-source-peach-fg shadow-none',
    inactive:
      'border border-transparent bg-transparent text-source-peach-fg hover:border-source-peach-border',
  },
  concept2: {
    active:
      'border border-source-concept2-border bg-transparent text-source-concept2-fg shadow-none',
    inactive:
      'border border-transparent bg-transparent text-source-concept2-fg hover:border-source-concept2-border',
  },
};

/** Card subtitle under metrics — source-colored when a single source is selected. */
export function sourceMetricSubtitleClass(sourceFilter: TrainingSourceFilter): string {
  if (sourceFilter === 'peach' || sourceFilter === 'concept2') {
    return SOURCE_METRIC_LABEL_CLASS[sourceFilter];
  }
  return 'text-content-muted';
}

export function sourceFilterSegmentClass(option: TrainingSourceFilter, active: boolean): string {
  if (option === 'all') {
    return active ? 'ui-btn--toggle-active' : 'ui-btn--toggle';
  }

  const tone = SOURCE_FILTER_SEGMENT_CLASS[option];
  return active ? tone.active : tone.inactive;
}
